export function classNames(cls, additionalCls = [], mode = {}) {
    return [
        cls,
        ...additionalCls.filter(Boolean),
        ...Object.entries(mode)
            .filter(([_, value]) => !!value)
            .map(([className]) => className),
    ].join(" ")
}
